'use strict';

import Resolver from '../resolver';
import { UseMetadata } from '../results';
import { extractOpenGraph } from '../metadata';

const POST_ID = /^\/(?:[^\/]+\/)?(?:reel|p|tv|reels)\/([^\/]+)(?:\/|$)/;

export default class Instagram extends Resolver {

	transformURL(url, ctx) {
		let match = POST_ID.exec(url.pathname);
		if ( match ) {
			ctx.post_id = match[1];
			//const url = new URL(`https://www.instagram.com/graphql/query/`);
			//url.searchParams.append('query_hash', 'b3055c01b4b222b8a47dc12b090e4e64');
			//url.searchParams.append('variables', JSON.stringify('shortcode', match[1]));
			//return url;

			return `https://www.ddinstagram.com/p/${match[1]}`;
		}

		// TODO: stories URLs

		return UseMetadata;
	}

	processBody(body, mode, ctx) {
		if ( ! body || mode !== 'html' )
			return UseMetadata;

		const meta = Array.from(body('meta')),
			og_data = extractOpenGraph(meta);

		console.log('data', og_data);

		const fragments = {};

		return {
			v: 9,
			i18n_prefix: 'embed.instagram',
			accent: og_data['theme-color'] ?? '#ffffff',

			fragments
		};
	}

}

Instagram.hosts = [
	'instagram.com',
	'www.instagram.com',
	'ddinstagram.com',
	'www.ddinstagram.com'
];

Instagram.examples = [
	{title: 'Home Page', url: 'https://www.instagram.com'},
	{title: 'Random Reel Post', url: 'https://www.instagram.com/pcgamer_mag/reel/C1IA4aPPLUM/?hl=en'}
];
